import React from 'react';
import { BodyText, Column } from '@chargify/custom-ui-components';
import { useTranslation } from 'react-i18next';
type Props = {
  productName: string;
  billingEndDate: string;
  proratedCreditAmount: string;
};

export const ProratedColumns = ({
  proratedCreditAmount,
  productName,
  billingEndDate,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <>
      <Column span={12}>
        <BodyText variant={'body2'} color={'gray.dark'} fontWeight={600}>
          {t('plan_change.prorated_credit', {
            planName: productName,
            date: billingEndDate,
          })}
        </BodyText>
      </Column>
      <Column span={12}>
        <BodyText textAlign={'right'} color={'success.main'} fontWeight={700}>
          {proratedCreditAmount}
        </BodyText>
      </Column>
    </>
  );
};
